
import { Pipe, PipeTransform } from '@angular/core';
import { padStart } from 'lodash';
import moment from 'moment';

@Pipe({
    name: 'duration',
    standalone: false
})
export class DurationPipe implements PipeTransform {
  transform(seconds: number, maxUnit = 'hours'): string {
    const duration = moment.duration(+seconds * 1000);
    if (maxUnit === 'minutes') {
      const paddedMinutes = padStart(Math.floor(duration.as('m')).toString(), 2, '0');
      return paddedMinutes + moment.utc(duration.as('ms')).format(':ss');
    } else {
      const paddedHours = padStart(Math.floor(duration.as('h')).toString(), 2, '0');

      return paddedHours + moment.utc(duration.as('ms')).format(':mm:ss');
    }
  }
}
